import socialList from "./constant/socialList";
const initState = () => ({
  search: null,
  socialList: socialList,
});

export default initState;